<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">{{ appName }}隐私政策摘要</div>
    </header-top>
    <div  class="privacy-wrapperZy">
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">成都陌陌科技有限公司（以下简称“我们”）非常注重保护您的个人信息及隐私。我们将通过本摘要向您简洁、清晰地说明我们会如何收集、使用、存储、保护您的个人信息，以及您享有的权利。如您希望了解我们详细的隐私政策，可通过“我的-设置-安全协议”查阅<b
          @click="gotoPage"
          style="text-decoration: underline;"
          >《{{ appName }}隐私政策》。</b></span>
        </p>
        <p class="dingdocnormal" style="text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">一、我们如何收集使用您的个人信息</span></p>
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">我们将结合具体服务逐一向您说明，我们针对某一特定功能所收集的具体个人信息种类、处理目的及方式。当您使用某一功能时，我们会遵循合法、正当、必要的原则，并在获得您的同意后收集您的一些个人信息。除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使您无法使用对应功能，但不影响您正常使用{{ appName }}的其他功能。</span>
        </p>
        <table cellspacing="0" cellpadding="0" class="Style7"
            style="border:0.75pt solid #d6d6d6; -aw-border-insideh:0.75pt single #d6d6d6; -aw-border-insidev:0.75pt single #d6d6d6; border-collapse:collapse">
            <tr>
                <td
                    style="width:157.5pt; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">场景/业务功能</span></p>
                </td>
                <td
                    style="width:157.5pt; border-right:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">收集方式</span></p>
                </td>
                <td
                    style="width:157.5pt; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">收集个人信息类型</span></p>
                </td>
            </tr>
            <tr>
                <td rowspan="2"
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">注册登录</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用户注册创建账号时主动填写</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">手机号码</span><span
                            style="font-family:宋体; font-size:12pt">、昵称、性别、生日</span></p>
                </td>
            </tr>
            <tr>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">第三方SDK提供登录服务时收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">第三方账号（头像、昵称及其他授权信息）、</span><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">手机号码</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">个人主页</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用户更新头像和完善个人主页时主动填写</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">相机、相册、麦克风、身高、体重、个性签名、个性标签、家乡、职业、收入情况、城市、婚姻状况、</span><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">本人真实头像</span><span
                            style="font-family:宋体; font-size:12pt">、择偶条件、录制语音、交友心声、年龄、星座</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">浏览查看附近用户、附近交友房间、附近动态</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用户授权同意后收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">地理位置信息</span></p>
                </td>
            </tr>
            <tr style="height:69pt">
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">发布图文/音视频、发表评论、关注、分享、点赞、创建家族、认证红娘/月老等功能</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用户主动填写及授权权限后收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">相册、相机、麦克风、</span><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">地理位置</span><span
                            style="font-family:宋体; font-size:12pt">、相关发布内容</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">实名认证</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">第三方SDK提供实名认证服务时收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">真实姓名、身份证号、生物识别特征</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">支付</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">第三方SDK为用户提供支付充值服务时提供</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">微信支付信息、支付宝支付信息、苹果支付信息</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">提现</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">第三方SDK提供提现服务时收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">支付宝账号信息、身份认证信息</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">消息聊天</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用户授权同意后收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">相册、相机、麦克风、</span><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">地理位置</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">客服沟通</span></p>
                </td>
                <td style="width:157.5pt; border:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用户授权同意后收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; border-bottom:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">通信/通话记录和内容（包括用户的账户信息、提供的相关投诉材料信息、联系方式）、身份核验信息</span><span
                            style="font-family:宋体; font-size:12pt">、相机、相册</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; vertical-align:top; background-color:#f5f6f7">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">安全保障</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-right:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">用户授权同意后收集</span></p>
                </td>
                <td
                    style="width:157.5pt; border-top:0.75pt solid #d6d6d6; border-left:0.75pt solid #d6d6d6; vertical-align:top">
                    <p class="dingdocnormal" style="widows:2; orphans:2"><span
                            style="font-family:宋体; font-size:12pt">账户信息、设备信息、服务日志信息、有关的</span><span
                            style="font-family:宋体; font-size:12pt; font-weight:bold">交易信息</span></p>
                </td>
            </tr>
        </table>
        <p class="dingdocnormal" style="text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">二、我们需要申请使用的设备权限</span></p>
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">为确保相关业务功能的正常实现，我们需要根据具体的业务场景调用对应的系统权限并在调用前向您弹窗询问。我们会遵循合法、正当、必要的原则，并在获得您的同意后进行调用。拒绝提供权限仅会使您无法使用对应功能，但不影响您正常使用{{ appName }}的其他功能。您可以在设备的设置功能中随时选择关闭部分或全部权限，使用不同的手机操作系统时，权限显示方式及关闭方式可能有所不同，如果无法找到相应的权限管理功能，可咨询设备及系统的提供方获得帮助。</span>
        </p>
        <p style="text-indent:24pt; line-height:22pt"><span
                style="font-family:宋体; font-size:12pt">关于{{ appName }}调用权限的具体情况，详见<b
          @click="goto4Page"
          style="text-decoration: underline;"
          >《设备权限清单》</b
        >。</span></p>
        <p class="dingdocnormal" style="text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">三、我们如何共享您的信息</span></p>
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">在我们向您提供产品/服务时，由于部分服务是我们无法单独完成的，因此我们会采取严格的安全措施与第三方合作伙伴共享或委托处理您的部分个人信息，以保障您能正常使用相关产品/服务。我们会{{ appName }}外提供信息的行为进行风险评估，并与授权的合作伙伴约定严格的信息保护和保密协议，要求其遵守协议并采取相关的安全措施保护您的个人信息。</span><span
                style="font-family:宋体; font-size:12pt; font-weight:bold">您可通过“我的-设置-第三方共享个人信息清单”查阅<b
          @click="goto3Page"
          style="text-decoration: underline;"
          >《第三方共享个人信息清单》</b
        >。</span>
        </p>
        <p class="dingdocnormal" style="text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">四、您如何管理您的个人信息</span></p>
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">您可以通过“我的-设置”访问、修改、补充、删除您的个人信息，也可以操作撤回同意、注销帐号、投诉举报等隐私功能或行使其他法定的个人信息主体权利。</span>
        </p>
        <p class="dingdocnormal" style="text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">五、如何联系我们</span></p>
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">如果您对本政策内容有任何疑问、意见或建议，您可以通过“{{ appName }}”客服（我的-联系客服）与我们联系。</span></p>
        <p class="dingdocnormal" style="text-indent:24pt; text-align:left; widows:2; orphans:2"><span
                style="font-family:宋体; font-size:12pt">如发现个人信息可能被泄露，您可以发邮件dataprivacy@hellogroup.com投诉举报。</span></p>
        <p style="text-indent:24pt; font-size:12pt"><span
                style="font-family:宋体">我们的常用办公地址为北京市朝阳区将台(地区)乡酒仙桥北路甲12号，个人信息保护相关负责人的联系方式为dataprivacy@hellogroup.com。</span>
        </p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
del {
  display: none;
}
ins {
  text-decoration: none;
}
.tabOther {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  table-layout: fixed;
  word-break: break-all;
  tr {
    font-size: 16px;
    .tr7 {
      word-break: break-all;
    }
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
  padding-bottom: 130px;
}
.privacy-wrapperZy {
  padding-top: 120px;
  padding: 120px 10px 0;
  width: 730px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

export default {
  name: "Privacy",
  data() {
    return {
      appName: this.$store.state.appName
    };
  },
  mounted() {
    console.log("appName:", this.appName);
  },
  components: {
    "header-top": HeaderTop // 顶部导航组件
  },
  methods: {
    gotoPage() {
      this.$router.push({
        name: "privacy"
      });
    },
    goto3Page() {
      this.$router.push({
        name: "privacyOther"
      });
    },
    goto4Page() {
      this.$router.push({
        name: "privacyQd"
      });
    },
  }
};
</script>
